import React from 'react';
import { Spin } from 'antd';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  className?: string;
  fullscreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'default',
  tip = '加载中...',
  className = '',
  fullscreen = false,
}) => {
  return (
    <div className={`flex justify-center items-center p-8 ${className}`}>
      {fullscreen ? (
        <Spin size={size} tip={tip} fullscreen />
      ) : (
        // 使用嵌套（nested）模式以启用 tip 展示
        <Spin size={size} tip={tip}>
          {/* 占位元素，确保为嵌套模式（可控制最小高度以稳定布局） */}
          <div style={{ minHeight: 64 }} />
        </Spin>
      )}
    </div>
  );
};

export default LoadingSpinner;
